export class ApiError {
    constructor(httpStatus, title, descriptionsArray) {
        this.httpStatus = parseInt(httpStatus) || 500;
        this.title = title || "Errore server";
        this.descriptionsArray = descriptionsArray || ["Si è verificato un errore sul server"];
    }
}